<template>
  <div id="accredif">
    <img
      src="../../../assets/image/h5/shouquanzhongxin_banner.png"
      alt=""
      class="banner"
    />
    <div class="info">
      <div class="title">
        <h3 class="name">培训合作伙伴介绍</h3>
        <span>Training partner introduction</span>
      </div>
      <p>
        依托国家广播电视总局广播电视和网络视听播音主持教育培训基地官方授权课程体系，面向公众市场推广全媒体运营师（职业编码：4-13-05-03）技能认证体系，赋能新经济形势下的数字化人才，助力事业发展。
      </p>
      <br />
      <p>
        我们的合作伙伴基于市场痛点，针对主播、全媒体运营师开展艺术技能培训、新媒体话题传播培训、个人IP打造、直播带货技巧、文化礼仪等全方位培训。
      </p>
    </div>
    <img src="../../../assets/image/h5/hezuohb.png" alt="" class="banners" />
    <div class="tobe">
      <div class="title">
        <h3>成为授权培训中心</h3>
        <span>Training partner introduction</span>
      </div>
      <p>
        加入我们在全球不断壮大的授权培训中心团队，您的培训机构正在开设全媒体运营师培训？申请成为广电官方授权培训中心的一员，传授高质量培训内容，为您的学员提供“全媒体运营师·网络视听主播”，“茶文化网络视听主播”技能认证考试，通过者可获得广电总局官方认证和技能等级鉴定证书。
      </p>
      <br /><br />
      <p>
        同时，我们热忱欢迎具有教育资源、政府资源、艺术培训资源、MCN机构以及想在新媒体培训行业大展宏图的有志之士加入我们的培训中心。
      </p>
    </div>
    <img src="../../../assets/image/h5/tu_hezuob.png" alt="" class="banners" />
    <div class="contact">
      <div class="title">
        <h3>授权合作伙伴</h3>
        <span>Authorized partner</span>
      </div>
      <div class="location">
        <div class="input_boxs sel_box">
          <el-select v-model="city" filterable @change="checkCity" placeholder="请选择">
            <el-option
              class="options"
              v-for="item in options"
              :key="item.code"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="" id="swiper">
        <swiper class="city_box" :options="swiperOption" ref="mySwiper">
          <swiper-slide
                v-for="item in citys"
                :key="item.id"
              >
              <div class="bottom">
                <img :src="item.logo" alt="" />
                <p class="title">
                  <span>{{ item.school }}</span>
                  <a :href="item.url">{{ item.url }}</a>
                </p>
                <p>电话:{{ item.phone }}</p>
                <div class="side"></div>
                <p>授权培训：{{ item.authorize }}</p>
                <p>授权地区：{{ item.area }}</p>
              </div>     
          </swiper-slide>
              <div class="no_bottom" v-if="citys.length === 0">
                暂无合作伙伴
              </div>
              <div  class="swiper-pagination" slot="pagination" style="display: flex; justify-content: center; padding: 0 0px"></div> 
        </swiper>
      </div>
    </div>
    <div id="bottom">
      <a class="left" onclick="_MICHAT.mini.startChat()">
        <img src="@/assets/image/h5/icon_dianhuazixun.png" alt="" />
        <p>在线咨询</p>
      </a>
      <a class="right" href="./index.html#plan">
        <img src="@/assets/image/h5/icon_baoming.png" alt="" />
        <p>获取方案</p>
      </a>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  metaInfo() {
    return this.metaData;
  },
  data() {
    return {
      options:[],
      citys:[],
      city:'四川',
      swiperOption:{
        observer: true,//修改swiper自己或子元素时，自动初始化swiper 
        observeParents: true,//修改swiper的父元素时，自动初始化swiper 
        slidesPerView: 1,
        spaceBetween: 15,
        slidesPerGroup: 1,
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          bulletClass: 'point',
          bulletActiveClass: 'active',
          clickable: true //允许分页点击跳转
        },
      },
      metaData: {
        title: "全媒体运营师培训合作授权_基地共建_MCN机构服务泽谷传媒", // set a title
        meta: [
          {
            // set meta
            name: "keyWords",
            content: "全媒体运营师培训合作授权、主播培训、主播输送",
          },
          {
            name: "description",
            content:
              "泽谷传媒是国家广播电视总局教育培训基地授权的全媒体运营师合作单位。对外招募全媒体运营师招生合作单位，共建电商主播培训基地。",
          },
        ],
      },
    };
    
  },
  components: {
    swiper,
    swiperSlide,
  },
  created(){
    this.$emit('showPC', false);
  },
  mounted() {
    this.locationStart()
    this.checkCity()
    if(!this.isMobile(navigator.userAgent)) {
      let url = window.location.origin.replace(/m./, "www.");
      window.location.href= url +'/page/accredit/accredif.html'
    }
  },
  methods: {
    // 判断是否为移动端
    isMobile(ua) {
      return !!ua.match(/AppleWebKit.*Mobile.*/)
    },
    // 行政地区初始化
    locationStart() {
      this.$axios
        .get(window.location.origin + "/location.json", { dataType: "json" })
        .then((res) => {
          this.options = Object.values(res);
        });
    },
    checkCity() {
      let params = this.city
      this.$axios.post("/city", { city: params }).then((res) => {
        this.citys = res ? res : [];
        this.swiper.update()
      });
    }
  },
};
</script>
<style lang="scss">
#swiper {

}
</style>
<style lang="scss" scoped>
#accredif {
  width: 100%;
  height: 100%;
  #bottom{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 44px;
    z-index: 99;
    display: flex;
    .left {
      border-right: 1px solid #FFFFFF;
    }
    >a {
      background: #FEB746;
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      color: #FFFFFF;
      text-decoration: none;
      p{
          margin: 0 ;
      }
    }
    img {
      display: block;
      width: 20px;
      margin-right: 7px;
    }
  }
  .banner {
    display: block;
    width: 100%;
  }
  .banners {
    display: block;
    width: 100%;
  }
  .info,.tobe,.contact{
    padding: 0 12px;
    margin: 38px 0 22px;
    font-size: 13px;
    .title {
      text-align: center;
      margin-bottom: 20px;
      h3 {
        font-size: 16px;
        color: #2b3748;
      }
      span {
        color: #7d8a9c;
        font-size: 10px;
      }
    }
    > p {
      text-align: left;
      font-size: 12px;
      line-height: 20px;
      color: #616975;
      margin: 0 auto;
    }
  }
  .location {
    .sel_box {
      width: 100%;
    }
  }
  .contact {
    padding-bottom: 75px;
    .city_box {
      margin-top: 20px;
      padding: 19px 0px 19px;
      text-align: left;
      img {
        display: block;
        width: 150px;
      }
      .title {
        margin-top: 10px;
        text-align: left;
        margin-bottom: 20px;
        > a {
        color: #00a4ff;
        }
      }
      .side {
        width: 100%;
        height: 1px;
        background-color: #dadee6;
        margin: 24px 0;
      }
      .bottom {
        padding: 19px 5px 19px 12px;
        border: 1px solid #dadee6;
      }
      .no_bottom {
        width: 100%;
        padding: 19px 5px 19px 12px;
        border: 1px solid #dadee6;
      }
    }
  }
  
}
</style>
<style lang="scss">
.location {
  .el-select {
    width: 100%;
  }
  
}
#swiper {
  .point,.active {
    background-color: #007aff;
    height: 4px;
    border-radius: 2px;
    width: 42px;
  }
}
</style>
